import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { setSession } from "@/lib/store";

// Handles the return from Emergent-managed Google OAuth: {origin}/w/projects#session_id=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const done = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/app", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => { setSession(data); window.history.replaceState(null, "", window.location.pathname); nav("/w/projects", { replace: true }); })
      .catch((e) => setErr(apiError(e)));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#0b0b0c] flex flex-col items-center justify-center gap-4 text-zinc-300" data-testid="auth-callback">
      {err ? (<><div className="text-red-400" data-testid="auth-callback-error">{err}</div><button onClick={() => nav("/app", { replace: true })} className="text-amber-400 hover:text-amber-300 text-sm">Back to sign in</button></>)
        : (<><Loader2 className="w-6 h-6 animate-spin text-amber-400" /><div className="text-sm">Signing you in with Google…</div></>)}
    </div>
  );
}
